import supreme from '../supreme'
import {guid,copy} from '../util/util'
import _ from 'lodash'
import Task from './Task'
var key = "supreme_history"
// 历史轨迹
export default{
  // 同步到历史记录
  asyncTaskStack(taskStack){
    var vueArray=[];
    for(var i=0;i<taskStack.length;i++){
      vueArray.push(taskStack[i].vue)
      delete taskStack[i].vue;
    }
    supreme.sessionCache.set(key,{taskStack:taskStack});
    for(var j=0;j<taskStack.length;j++){
        taskStack[j].vue=vueArray[j];
    }
    //if()
  },
  //获取本地存储的浏览历史
  getLocalTaskHistory(){
    var historyTasks=supreme.sessionCache.get(key)?supreme.sessionCache.get(key).taskStack:[];
    return this.unserializeTasks(historyTasks);
    //return supreme.sessionCache.get(key)?supreme.sessionCache.get(key).taskStack:[];

  },
  clear(){
    supreme.sessionCache.delete(key);
  },
    /**
     * @description 反序列化本地存储至对象
     * @param tasks {array}
     * */
    unserializeTasks(tasks){
      var taskArray=[];
    for(let [index,task] of tasks.entries()){
      var t = new Task();
      _.assign(t,task);
      taskArray.push(t);
    }
    return taskArray;
  }
}
